module.exports = __webpack_public_path__ + "static/media/instagram.99920e77.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/instagram.svg
// module id = 354
// module chunks = 1